import { useParamNumbers } from "helpers/hooks/useParamNumbers";
import { Navigate, useNavigate } from "react-router";
import { useAppSelector } from "redux/hooks";
import { selectProfileBuilderCellsByFieldId } from "redux/slices/lensEditor";
import Cells from "./Cells";
import { Cell } from "generated/graphql";

export const ProfileBuilderCells = () => {
  const { fieldId } = useParamNumbers(["fieldId"]);
  const navigate = useNavigate();
  const fieldCells = useAppSelector((state) => selectProfileBuilderCellsByFieldId(state, fieldId));
  const handleCellClick = (cell: Cell) => {
    navigate(cell.id.toString());
  };

  if (fieldId === undefined) {
    return <Navigate to=".." />;
  }

  return <Cells cells={fieldCells} fieldId={fieldId} handleCellClick={handleCellClick} />;
};
